<template>
	<div class="content">
		<Header />
		<Banner :src="src" />
		<!-- produvct_banner -->
		<div class="pro_center m">
			<h2>解决方案</h2>

			<div class="m_pro_tab">
				<div class="m_pro_tab_select">
					<p>产品展示</p>
					<span @click="tabShow">{{
						isTabShow ? '点击收起-' : '点击展开+'
					}}</span>
				</div>
				<!-- 下拉列表部分 -->
				<div class="pro_c_m">
					<div class="pro_c_l" v-show="isTabShow">
						<Mytree />
					</div>
					<!-- l -->

					<!-- 选项卡部分 -->

					<!-- r -->
				</div>
			</div>
			<!-- 移动端tab -->
			<!-- pc隐藏 -->
			<div class="pro_c">
				<div class="pro_c_l">
					<h2>
						解决方案
						<p>PRODUCTS CENTER</p>
					</h2>
					<Mytree />
				</div>
				<router-view />
			</div>
		</div>
		<!-- product_center -->
		<Footer />
	</div>
</template>

<script>
import Header from '../../components/Header.vue'
import Banner from '../../components/Banner.vue'
import Footer from '../../components/Footer.vue'
import Mytree from '../../components/MenuList1.vue'
import Axios from 'axios'
import Vue from 'vue'
Vue.config.warnHandler = function(msg, vm, trace) {
    console.log(`Warn: ${msg}\nTrace: ${trace}`);
  }
const Base64 = require('js-base64')
export default {
	components: { Header, Banner, Footer, Mytree },
	data() {
		return {
			src: '',
			activeName: 'first',
			tabName: '',
			actChild: false,
			isTabShow: false,
			p_data: [
				{
					id: 1,
					name: '名称',
					img_url: 'http://www.37digit.com/static/img/banner_1.c18a137.png',
				},
				{
					id: 2,
					name: '名称',
					img_url: 'http://www.37digit.com/static/img/banner_1.c18a137.png',
				},
				{
					id: 3,
					name: '名称',
					img_url: 'http://www.37digit.com/static/img/banner_1.c18a137.png',
				},
			],
			m_tabList: [
				{
					id: 1,
					tab_name: ' 智能硬件',
					order: 'first',
					txt: {
						img_src:
							'http://pbyuan.yuanmaqi.com/pbyuan7762z/template/demo/skin/images/aboutm.jpg',
						title: '智能硬件',
					},
				},
				{
					id: 2,
					tab_name: ' GiMAC',
					order: 'second',

					txt: { img_src: '', title: 'GiMAC' },
				},
				{
					id: 3,
					order: 'third',

					tab_name: ' 物联网应用软件平台',
					children: [{ id: '_1', txt: '智能家居' }],
					txt: { img_src: '', title: '物联网应用软件平台' },
				},
				{
					id: 4,
					order: 'fourth',
					tab_name: ' 企业级宽带无线',
					txt: { img_src: '', title: '企业级宽带无线' },
				},
				{
					id: 5,
					order: 'fifth',

					tab_name: ' 专用软件',
					txt: { img_src: '', title: '专用软件' },
				},
			],
			content: [],
			contentone: [],
			contenttwo: [],
			contentthree: [],
			contentfour: [],
			contentfive: [],
			contentsix: [],
			treeList: [],
		}
	},
	async mounted() {
		this.tabName = this.$route.params.active + ''
		this.tabName == 'undefined' ? (this.tabName = '1') : this.tabName
		Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
       let common=res.data.data.rows
			for (var i = 0; i <common.length; i++) {
				if (
					common[i].sc_key.slice(0, 22) == 'SOLUTION_DETAIL_BANNER'
				) {
					this.src = common[i].sc_value
				}
			}
        })	
	},
	methods: {
		handleSelect(key, keypath) {
			this.tabName = key
			this.isTabShow = false
		},
		handleClick(tab, event) {
			// console.log(tab.label)
			// if (tab.label === '物联网应用软件平台') {
			// 	this.actChild = true
			// } else {
			// 	this.actChild = false
			// }
		},
		handleCommand(command) {
			this.$message('click on item ' + command)
		},
		goDetail() {
			this.tabName = '物联网'
		},
		P_detail() {
			//console.log(1)
		},
		tabShow() {
			this.isTabShow = !this.isTabShow
		},
	},
}
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	@import './index.scss';
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m-index.scss';
}
</style>